import {Filter, FilterProps} from "../Filter";
import {html} from "htm/preact";

interface TextSearchProps extends FilterProps{
    defaultSearch: boolean;
    searchString: string;
}

export class TextSearch extends Filter<TextSearchProps> {
    defaultSearch: boolean;
    active: boolean = false;

    cleared: any = { searchString: "" }

    constructor(props: any) {
        super(props);
        this.defaultSearch = props.defaultSearch;

        this.handleSearch = this.handleSearch.bind(this);

        let searchString: string = props.preloadedState.value.searchString;


        if(searchString == "" || searchString == undefined){
            this.setStateValue({searchString: ""})
            this.active = false;
        }
        else if(searchString != ""){
            this.active = true;
            this.filtersManager?.addActiveFilter(this);
            this.setStateValue({searchString: searchString})
        }

    }

    render() {
        return html `
            <div class="govuk-form-group">
                <label class="govuk-label hidden" for="search">Search</label>
                <input class="govuk-input" id="filter-search" name="search" type="text" value="${this.state.value?.searchString}" placeholder="Search" onsearch=${this.handleSearch} onkeyup=${this.handleSearch}/>
            </div>
        `
    }

    clearSearch = () => {
        this.setStateValue(this.cleared);
        this.active = false;
        this.filtersManager?.removeActiveFilter(this);
        this.applySearch("");
    }

    //add event listeners to inputs
    handleSearch = (event: KeyboardEvent) => {
        if(event.key === "Enter") {
            const target = event.target as HTMLInputElement;
            this.setStateValue({searchString: target.value});
                this.applySearch(target.value);
        }
    }

    public applySearch(searchString: string) {
        if(searchString == this.state.value.searchString){
            return;
        }

        if(searchString != '' && !this.active){
            this.filtersManager?.addActiveFilter(this);
            this.active = true;
        }
        else if(searchString == '' && this.active){
            this.filtersManager?.removeActiveFilter(this);
            this.active = false;
        }

        this.filtersManager?.handleTextSearch(searchString);
    }

    getQueryParam(): Record<string, string> {
        let params: { [key: string]: string } = {};
        if(this.state.value?.searchString){
            params[this.id] = this.state.value.searchString;
        }
        else{
            return {};
        }
        return params;
    }

}